/* global axios */
import ApiClient from '../ApiClient';

// T-255: cumprimento de SLA por agente, time, caixa ou etiqueta.
class SlaQuebraAPI extends ApiClient {
  constructor() {
    super('fandata/sla_quebra', { accountScoped: true });
  }

  get({ dim, since, until } = {}) {
    return axios.get(this.url, { params: { dim, since, until } });
  }
}

export default new SlaQuebraAPI();
